export default __webpack_public_path__ + "static/media/480_dummy2016-yoga02-de.e399095d.png";